import {z} from 'zod'

import {AspectRatioEnum, BlockKeyFactVisualizationEnum, CreateOrUpdateBlockKeyFactDocument} from '@sdox/api'

import {createMetaSchema} from '../../utils/getCreateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {buttonFormToInput} from '../../utils/buttonMappers'
import {KeyFactForm} from '../../SharedForms/KeyFact/KeyFactForm'
import {keyFactBlockSchema} from '../../utils/schemas/keyFactSchemas'

import type {ButtonFormSchema} from '../../utils/schemas'
import type {BlockKeyFactInput, BlockKeyFactItemInput, CreateOrUpdateBlockKeyFactMutation} from '@sdox/api'

type CreateKeyFactsValidatorSchema = z.infer<typeof createKeyFactsValidatorSchema>

const createKeyFactsValidatorSchema = z.object({
  data: keyFactBlockSchema,
  meta: createMetaSchema,
})

export const keyFactsConfig = createFormConfig<
  CreateKeyFactsValidatorSchema,
  CreateOrUpdateBlockKeyFactMutation,
  BlockKeyFactInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockKeyFactDocument,
  },
  fieldMapper: ({data}) => {
    const {visualization, aspectRatio} = data
    const items = data.items.map<BlockKeyFactItemInput>((item) => ({
      title: item.title,
      text: item.text,
      fileHash: item.image?.fileHash,
      // TODO: needs to be implemented in the form in a future iteration
      mediaDivider: false,
      cta: buttonFormToInput(item.cta as ButtonFormSchema),
    }))

    return {
      visualization,
      aspectRatio: aspectRatio ?? null,
      items,
    }
  },
  validatorSchema: createKeyFactsValidatorSchema,
  customFormNode: <KeyFactForm />,
  getDefaultValues: () => {
    return {
      data: {
        visualization: BlockKeyFactVisualizationEnum.WithImage,
        aspectRatio: AspectRatioEnum.Aspect_3_2,
      },
    }
  },
})
